import React from 'react';
import { WorkflowPlaybookModule } from '../../services/legacyApi';
import { Card, CardContent } from '../ui/card';
import { FlowPathBadge } from './FlowPathBadge';

type ModulePlaybookViewProps = {
    module: WorkflowPlaybookModule;
};

export const ModulePlaybookView: React.FC<ModulePlaybookViewProps> = ({ module }) => {
    return (
        <Card>
            <CardContent className="space-y-4 p-6">
                <div>
                    <h2 className="text-xl font-semibold text-foreground">{module.module_label}</h2>
                    <p className="text-sm text-muted-foreground">{module.description || 'Workflow guidance'}</p>
                </div>

                <div className="space-y-4">
                    {(module.paths || []).map((path) => (
                        <div key={path.path_key} className="rounded-lg border bg-slate-50 p-4">
                            <div className="flex flex-wrap items-center justify-between gap-2">
                                <h3 className="text-sm font-semibold text-slate-900">{path.label}</h3>
                                <FlowPathBadge label={path.label} />
                            </div>
                            {path.description ? <p className="mt-1 text-sm text-slate-600">{path.description}</p> : null}
                            <ol className="mt-3 list-decimal space-y-1 pl-5 text-sm text-slate-700">
                                {(path.steps || []).map((step) => (
                                    <li key={step.step_key}>
                                        <span className="font-medium">{step.label}</span>
                                        {step.prerequisites?.length ? (
                                            <span className="text-slate-500"> - {step.prerequisites.join(', ')}</span>
                                        ) : null}
                                    </li>
                                ))}
                            </ol>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    );
};

